import { ConsoleLogger } from "../modules/logger/ConsoleLogger"
import { Logger } from "../modules/logger/Logger"

export const logger: Logger = new ConsoleLogger()
